import React from "react";

export const GalleryContentContext = React.createContext({ galleryContentShow: true, setGalleryContentShow: () => { } });